import React from 'react'
import ReactPlayer from 'react-player'
import styled from 'styled-components'
import Dropzone from '../Dropzone'

const PickerWrapper = styled.div`
    position: relative;
`

interface VideoPlayerProps {
    source?: string
}

const VideoPlayerWrapper = styled.div<VideoPlayerProps>`
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: ${props => props.source ? '#FFF' : '#C4C4C4'};
`

interface FilePickerProps {
    placeholderTitle: string
    placeholderText: string
    value: string
    onChangeVideo: (image: File, onUploadProgress: (progress: number) => void, onSuccessCallback: () => void, onErrorCallback: (reason: string) => void) => void
}

const VideoReplacePicker: React.FC<FilePickerProps> = ({ placeholderTitle, placeholderText, value, onChangeVideo }) => {
    return (
        <PickerWrapper>
            {!value ?
                <Dropzone
                    accept="video/mp4"
                    placeholderTitle={placeholderTitle}
                    placeholderText={placeholderText}
                    onDropFile={onChangeVideo}
                />
                :
                <VideoPlayerWrapper source={value}>
                    <ReactPlayer url={value} controls width="100%" height="100%" />
                </VideoPlayerWrapper>
            }
        </PickerWrapper>
    )
}

export default VideoReplacePicker
